var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimeClockChecked = function SvgTimeClockChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.53 1.53A.75.75 0 0 0 3.47.47l-3 3a.75.75 0 0 0 1.06 1.06l3-3ZM2.75 11a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0ZM11 1.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S16.385 1.25 11 1.25Zm6.47-.78a.75.75 0 0 0 0 1.06l3 3a.75.75 0 1 0 1.06-1.06l-3-3a.75.75 0 0 0-1.06 0Zm-1.94 8.06a.75.75 0 0 0-1.06-1.06L10 11.94l-1.47-1.47a.75.75 0 0 0-1.06 1.06l2 2a.75.75 0 0 0 1.06 0l5-5Z",
    fill: "#050400"
  })));
};
export default SvgTimeClockChecked;